module.exports = __webpack_public_path__ + "static/media/L3.7168b290.svg";